<template>
  <div class="import-progress-container">
    <FriedProgressBar
      data-external="import-progress-container-progress-bar"
      :value="progress.percentage"
      :completed="progress.status === ImportStatus.Completed"
      :error="progress.status === ImportStatus.Error"
      class="progress-bar"
    />
    <FriedParagraph data-external="import-progress-container-message">
      {{ progress.message }}
    </FriedParagraph>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import type { ImportProgress } from '../types/import-progress';
import { ImportStatus } from '../types/enums/import-status';
import { ImportType } from '../types/enums/import-type';

export default defineComponent({
  props: { progress: { type: Object as PropType<ImportProgress>, required: true } },
  setup() {
    return { ImportType, ImportStatus };
  },
});
</script>

<style lang="scss" scoped>
.import-progress-container {
  padding: var(--spacing-75);
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--spacing-100);
  text-align: center;

  @keyframes shine {
    0% {
      background-position: right;
    }
  }
}
</style>
